"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _reactFinalForm = require("react-final-form");
var _japaneseAndRoman = _interopRequireWildcard(require("@htmniseko/htm-validators/utils/ASCII/japaneseAndRoman"));
var _FormField = _interopRequireDefault(require("./FormField"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var InputTextField = function InputTextField(_ref) {
  var id = _ref.id,
    displayValue = _ref.displayValue,
    errorMessage = _ref.errorMessage,
    hideErrorLabel = _ref.hideErrorLabel,
    hideLabel = _ref.hideLabel,
    labelId = _ref.labelId,
    required = _ref.required,
    styleContainer = _ref.styleContainer,
    styleInput = _ref.styleInput,
    styleInputError = _ref.styleInputError,
    styleWrapper = _ref.styleWrapper,
    type = _ref.type;
  return _react["default"].createElement(_reactFinalForm.Field, {
    id: id,
    name: id,
    component: _FormField["default"],
    displayValue: displayValue,
    errorMessage: errorMessage,
    hideErrorLabel: hideErrorLabel,
    hideLabel: hideLabel,
    labelId: labelId,
    normalize: _japaneseAndRoman["default"],
    parse: _japaneseAndRoman.cleanseJapaneseAndRoman,
    required: required,
    styleContainer: styleContainer,
    styleInput: styleInput,
    styleInputError: styleInputError,
    styleWrapper: styleWrapper,
    type: type
  });
};
InputTextField.defaultProps = {
  styleContainer: {},
  styleInput: {},
  styleInputError: {},
  styleWrapper: {},
  type: 'text'
};
var _default = exports["default"] = InputTextField;